module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-menu', {
    staticClass: "main-toolbar__menu",
    attrs: {
      "mode": "horizontal"
    },
    on: {
      "select": _vm.onSelect
    }
  }, [(_vm.mode !== 'main') ? _c('el-menu-item', {
    staticClass: "main-toolbar-back__menu-item",
    attrs: {
      "index": "back"
    }
  }, [_c('i', {
    staticClass: "el-icon-back"
  })]) : _vm._e(), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "about"
    }
  }, [_vm._v("About")]), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "projects"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("Projects")]), _vm._v(" "), _vm._l((_vm.availableProjects), function(project) {
    return _c('el-menu-item', {
      key: project.id,
      attrs: {
        "index": project.id
      }
    }, [_vm._v("\n      " + _vm._s(project.label) + "\n    ")])
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-de292316","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/toolbar/toolbar.vue
// module id = 293
// module chunks = 0